import { render, staticRenderFns } from "./RuleAction.vue?vue&type=template&id=68adf08f&scoped=true&"
import script from "./RuleAction.vue?vue&type=script&lang=ts&"
export * from "./RuleAction.vue?vue&type=script&lang=ts&"
import style0 from "./RuleAction.vue?vue&type=style&index=0&id=68adf08f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68adf08f",
  null
  
)

export default component.exports